
import React from 'react';
import MainLayout from '@/components/Layout/MainLayout';
import TheFortiFiDifference from '@/components/About/TheFortiFiDifference';
import HNWIProcess from '@/components/About/HNWIProcess';
import AnimateInView from '@/components/ui/animate-in-view';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const About = () => {
  return (
    <MainLayout>
      {/* Hero Section */}
      <section className="bg-forti-fi-dark py-20 px-4 text-white" aria-labelledby="about-hero-heading">
        <div className="container mx-auto max-w-4xl text-center">
          <h1 id="about-hero-heading" className="text-white mb-6">About Forti-Fi</h1>
          <p className="text-forti-fi-lavender text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
            Redefining perimeter security through innovation and discretion
          </p>
        </div>
      </section>
      
      {/* Our Mission Section - Re-added content */}
      <section className="py-16 px-4 bg-white" aria-labelledby="our-mission-heading">
        <div className="container mx-auto max-w-4xl">
          <AnimateInView animation="fade-in">
            <h2 id="our-mission-heading" className="text-center mb-10">Our Mission</h2>
            
            <div className="prose prose-lg prose-stone max-w-none">
              <p className="text-xl text-forti-fi-charcoal mb-6">
                At Forti-Fi, we're redefining what perimeter security means in the modern era. Our innovative approach combines cutting-edge technology with practical, aesthetically-conscious solutions that protect without intruding.
              </p>
              
              <p className="text-xl text-forti-fi-charcoal mb-6">
                We believe that the most effective security is often invisible, working silently in the background to detect and deter threats before they become incidents.
              </p>
              
              <p className="text-xl text-forti-fi-charcoal mb-8">
                Our team brings together expertise from military, infrastructure protection, and technology sectors to create solutions that are as elegant as they are effective.
              </p>
              
              <div className="text-center">
                <Button asChild variant="gradient" className="text-white">
                  <Link to="/solutions">
                    Explore Our Solutions <ArrowRight className="ml-2 h-4 w-4" />
                  </Link>
                </Button>
              </div>
            </div>
          </AnimateInView>
        </div>
      </section>
      
      {/* The Forti-Fi Difference */}
      <TheFortiFiDifference />
      
      {/* Our Approach */}
      <HNWIProcess />
      
      {/* Industries Served - Brief Overview with Link */}
      <section className="py-16 px-4 bg-forti-fi-background" aria-labelledby="industries-heading">
        <div className="container mx-auto max-w-4xl">
          <AnimateInView animation="fade-in">
            <h2 id="industries-heading" className="text-center mb-10">Industries We Serve</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
              <div className="text-center p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <h3 className="text-forti-fi font-semibold text-xl mb-2">Industrial Complexes</h3>
                <p className="text-forti-fi-charcoal mb-0">Pipelines, refineries, power plants</p>
              </div>
              
              <div className="text-center p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <h3 className="text-forti-fi font-semibold text-xl mb-2">Agriculture</h3>
                <p className="text-forti-fi-charcoal mb-0">Farms, solar arrays, livestock</p>
              </div>
              
              <div className="text-center p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <h3 className="text-forti-fi font-semibold text-xl mb-2">Luxury Real-Estate</h3>
                <p className="text-forti-fi-charcoal mb-0">Estates, golf courses, resorts</p>
              </div>
              
              <div className="text-center p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <h3 className="text-forti-fi font-semibold text-xl mb-2">Utilities</h3>
                <p className="text-forti-fi-charcoal mb-0">Water treatment, substations, communication towers</p>
              </div>
            </div>
            
            <div className="text-center">
              <Button asChild variant="gradient" className="text-white">
                <Link to="/industries">
                  View All Industries <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </AnimateInView>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="bg-forti-fi-dark text-white py-16 px-4">
        <div className="container mx-auto max-w-3xl text-center">
          <AnimateInView animation="fade-in">
            <h2 className="text-white mb-6">Ready to Secure Your Property?</h2>
            <p className="text-forti-fi-lavender mb-8 text-lg">
              Connect with our team to discuss your specific security requirements and discover how our innovative solutions can provide unparalleled protection.
            </p>
            <Button asChild size="default" variant="gradient" className="text-white">
              <Link to="/contact">
                Contact Us Today
              </Link>
            </Button>
          </AnimateInView>
        </div>
      </section>
    </MainLayout>
  );
};

export default About;
